<template>
  <div class="side-menu--container">
    <!-- <div class="side-menu--actions-btn-group">
      <a-popover placement="right" trigger="hover">
        <template slot="content">
          Randomize
        </template>
        <a-button class="randomize-btn" size="large" shape="circle">
          <randomize-icon :style="{ width: '18px' }" />
        </a-button>
      </a-popover>

      <a-popover placement="right" trigger="hover">
        <template slot="content">
          Suggest
        </template>
        <a-button class="favorite-btn" size="large" shape="circle">
          <favorite-icon :style="{ width: '18px' }" />
        </a-button>
      </a-popover>
    </div> -->
    <!-- <div class="side-menu--suggestion-group">
      <div class="suggestion-group--title">
        Your suggestion
      </div>
      <div class="suggestion-group--item">
        <img src="../../assets/images/glasses_style.png" alt="suggestion_img" />
      </div>
      <div class="suggestion-group--item">
        <img src="../../assets/images/glasses_style.png" alt="suggestion_img" />
      </div>
      <div class="suggestion-group--item">
        <img src="../../assets/images/glasses_style.png" alt="suggestion_img" />
      </div>
      <div class="suggestion-group--item">
        <img src="../../assets/images/glasses_style.png" alt="suggestion_img" />
      </div>
    </div> -->
    <div class="side-menu--order-section">
      <a-button size="large" class="order-btn" @click="createOrderAndRedirect">
        <div class="order-btn--content">
          <span class="title">Go to order</span> <right-arrow-icon :style="{ fontSize: '18px' }" />
        </div>
      </a-button>
    </div>
  </div>
</template>

<script>
import { Modal } from "ant-design-vue";
import qs from "querystring";
import { imageToBlob, createOrder } from "../../utils";
import { RightArrowIcon } from "../Icons";

export default {
  components: {
    // RandomizeIcon,
    // FavoriteIcon
    RightArrowIcon
  },
  props: ["setFetching", "snapshot"],
  computed: {
    options() {
      return this.$store.state.selectedOpt;
    },
    orderId() {
      return this.$store.state.orderId;
    }
  },
  methods: {
    async createOrderAndRedirect() {
      try {
        this.setFetching(true);
        const thumb = await this.snapshotAndUpload();
        const order = await createOrder(this.options, this.$store.state.pd, thumb, this.orderId);
        const productDetailUrl =
          "https://glasson-spring-knowledge-global.myshopify.com/collections/frontpage/products/glasses-tryon";
        const params = qs.stringify({
          orderId: order.id,
          style: order.options.find(option => option.kind === "style").sku,
          rim: order.options.find(option => option.kind === "rim").sku,
          temple: order.options.find(option => option.kind === "temple").sku,
          lens: order.options.find(option => option.kind === "lens").sku,
          pd: order.pd,
          thumb
        });
        window.parent.location.href = productDetailUrl + `?${params}`;
      } catch (err) {
        console.error(err);
        Modal.error({ title: "Exception", content: err.message });
      } finally {
        this.setFetching(false);
      }
    },
    snapshotAndUpload() {
      return new Promise((resolve, reject) => {
        const snapshot = this.snapshot();
        imageToBlob(snapshot.src).then(blob => {
          const formData = new FormData();
          formData.append("file", blob, "snapshot.jpg");
          fetch("https://glasson.sk-global.biz/api/v2/Attachments/production-glasson/upload", {
            method: "POST",
            body: formData
          })
            .then(res => res.json())
            .then(jsonResult => resolve(jsonResult.result.files.file[0].providerResponse.location))
            .catch(err => reject(err));
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.side-menu {
  &--actions-btn-group {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    .randomize-btn {
      border: 2px solid #2f80ed;
    }

    .favorite-btn {
      margin-top: 16px;
      border: 2px solid #2f80ed;

      @media only screen and (max-width: 768px) {
        margin-top: 0px;
      }
    }

    @media only screen and (max-width: 768px) {
      flex-direction: row;
      justify-content: space-around;
      align-items: flex-start;
    }
  }

  &--suggestion-group {
    width: 100%;
    margin-top: 24px;
    border: 2px solid #9a9b9c;
    border-radius: 8px;
    padding: 8px 48px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    @media only screen and (max-width: 768px) {
      flex-direction: row;
      white-space: nowrap;
      border-radius: 0;
      border: transparent;
    }

    &--title {
      color: #9a9b9c;
      font-size: 16px;

      @media only screen and (max-width: 768px) {
        display: none;
      }
    }

    &--item {
      img {
        width: 100%;
      }
    }
  }

  &--order-section {
    margin-top: 18px;
    display: flex;
    justify-content: center;
    align-items: center;

    .order-btn {
      border: 2px solid #f9d802;
      border-radius: 80px;
      width: 220px;
      height: 54px;
      background: #f9d802;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

      &--content {
        display: flex;
        justify-content: center;
        align-items: center;

        .title {
          color: #333333;
          font-size: 1.125rem;
          font-weight: 600;
          margin-right: 12px;
        }
      }

      &:hover,
      &:focus {
        color: rgba(0, 0, 0, 0.65);
      }

      @media only screen and (max-width: 768px) {
        // width: 60%;
      }
    }

    @media only screen and (max-width: 768px) {
      // margin-top: 48px;
    }
  }
}
</style>
